export const transferDateFormat = (date: string) =>
    date.split("/").reverse().join("-");

